import { AppState } from 'store/store';

export const accessRulesSelector = (state: AppState) => ({
  ...state.accessRules,
});
